import API from '@/services/api'

// Actions
export const FETCH_PROJECTS = 'fetchProjects'
export const FETCH_PROJECT = 'fetchProject'
export const GENERATE_REPORT = 'generateReport'
export const CREATE_PROJECT = 'createProject'
export const CREATE_EMPTY_PROJECT = 'createEmptyProject'
export const UPDATE_PROJECT = 'updateProject'
export const DELETE_PROJECT = 'deleteProject'
export const UPLOAD_FILE = 'uploadFile'

// Mutations
export const STORE_SET_PROJECTS = 'storeSetProjects'
export const STORE_ADD_PROJECT = 'storeAddProject'
export const STORE_UPDATE_PROJECT = 'storeUpdateProject'
export const STORE_DELETE_PROJECT = 'storeDeleteProject'
export const STORE_ADD_FILE = 'storeAddFile'

// Only the latest request may update the list, so slow responses for older search terms are ignored
let latestProjectsRequest = 0

const state = {
	projects: {
		data: [],
		meta: {
			total: 0,
			per_page: 15,
			from: 1,
			to: 0,
			current_page: 1,
		},
	},
}

const getters = {
	projects (state) {
		return state.projects
	},
}

const actions = {
	[FETCH_PROJECTS] (context, options) {
		const request = ++latestProjectsRequest
		let query = 'projects?page=' + options.page

		if (options.search) {
			query += '&search=' + encodeURIComponent(options.search)
		}

		return new Promise((resolve, reject) => {
			API.query(query).then((response) => {
				if (request === latestProjectsRequest) {
					context.commit(STORE_SET_PROJECTS, response.data)
				}
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_PROJECT] (context, project) {
		return new Promise((resolve, reject) => {
			API.query('projects/' + project).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[GENERATE_REPORT] (context, object) {
		return new Promise((resolve, reject) => {
			API.post('projects/' + object.project + '/report', { reference: object.reference }).then((response) => {
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[CREATE_PROJECT] (context, project) {
		return new Promise((resolve, reject) => {
			API.post('projects', project).then((response) => {
				context.commit(STORE_ADD_PROJECT, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[CREATE_EMPTY_PROJECT] () {
		return new Promise((resolve, reject) => {
			API.post('projects').then((response) => {
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[UPDATE_PROJECT] (context, object) {
		return new Promise((resolve, reject) => {
			API.update('projects', object.id, object.changes).then((response) => {
				context.commit(STORE_UPDATE_PROJECT, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[DELETE_PROJECT] (context, project) {
		return new Promise((resolve, reject) => {
			API.delete('projects/' + project.id).then((response) => {
				context.commit(STORE_DELETE_PROJECT, project)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[UPLOAD_FILE] (context, data) {
		return new Promise((resolve, reject) => {
			console.log(data)

			API.post('projects/' + data.project + '/documents', data.data).then((response) => {
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
}

const mutations = {
	[STORE_SET_PROJECTS] (state, projects) {
		state.projects = projects
	},
	[STORE_ADD_PROJECT] (state, project) {
		state.projects.data.push(project)
	},
	[STORE_UPDATE_PROJECT] (state, project) {
		let projects = []

		state.projects.data.map((mapProject) => {
			if (mapProject.id === project.id) {
				mapProject = project
			}

			projects.push(mapProject)
		})

		state.projects.data = projects
	},
	[STORE_DELETE_PROJECT] (state, project) {
		state.projects.data.splice(state.projects.data.indexOf(project), 1)
	},
}

export default { state, getters, actions, mutations }